import {jsx as _jsx} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {datadogRum} from '@datadog/browser-rum'
import {Component,} from 'react'

import useAtmosphere from '~/hooks/useAtmosphere'
import SendClientSideEvent from '~/utils/SendClientSideEvent'
import {isIgnoredError, isNotSignedInError} from '../utils/errorFilters'
import ErrorComponent from './ErrorComponent/ErrorComponent'













const sendClientError = (payload) => {
  if (typeof window === 'undefined') return
  window
    .fetch('/client-error', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(payload),
      keepalive: true
    })
    .catch(() => {
      // Avoid recursive ErrorBoundary failures from reporting failures.
    })
}

class ErrorBoundary extends Component {constructor(...args) { super(...args); ErrorBoundary.prototype.__init.call(this); }
  __init() {this.state = {
    error: undefined,
    errorInfo: undefined,
    eventId: undefined,
    isIgnoredError: false
  }}

  componentDidUpdate() {
    const {error, isIgnoredError} = this.state
    if (!error || isIgnoredError) return
    const {atmosphere} = this.props
    SendClientSideEvent(atmosphere, 'Fatal Error')
  }

  componentDidCatch(error, errorInfo) {
    const {atmosphere} = this.props
    if (isNotSignedInError(error)) {
      atmosphere.invalidateSession('Not signed in')
    }
    const {viewerId} = atmosphere
    const store = atmosphere.getStore()
    const email = _nullishCoalesce(_optionalChain([(_optionalChain([store, 'optionalAccess', _ => _.getSource, 'optionalCall', _2 => _2(), 'access', _3 => _3.get, 'optionalCall', _4 => _4(viewerId)]) ), 'optionalAccess', _5 => _5.email]), () => ( ''))
    const ignoredError = isIgnoredError(error)
    const eventId = crypto.randomUUID()
    this.setState({
      error,
      errorInfo,
      eventId,
      isIgnoredError: ignoredError
    })

    const {componentStack} = errorInfo
    datadogRum.addError(error, {viewerId, email, componentStack, eventId})
    if (!ignoredError) {
      sendClientError({
        eventId,
        viewerId,
        message: error.message,
        stack: error.stack,
        componentStack,
        url: window.location.href,
        userAgent: navigator.userAgent
      })
    }
  }

  render() {
    const {error, eventId} = this.state
    if (error && eventId) {
      const {fallback} = this.props
      return fallback ? (
        fallback(error, eventId)
      ) : (
        _jsx(ErrorComponent, { error: error, eventId: eventId,} )
      )
    }
    // Normally, just render children
    return this.props.children
  }
}

const ErrorBoundaryFn = (props) => {
  const atmosphere = useAtmosphere()
  return _jsx(ErrorBoundary, { ...props, atmosphere: atmosphere,} )
}

export default ErrorBoundaryFn
